export default "__VITE_ASSET__c95769c8__"